module.exports = __webpack_public_path__ + "img/pleasure-icon-5.334bf94e.svg";